import $ from 'jquery';
import { ENDERECO_API } from '../../config/constant';
import { decode as rawBase64Decode, encode as base64_encode } from 'base-64';
import { showDuplicateLoginAlert } from '../../components/Auth/DuplicateLoginAlert';

const normalizeHistoryNfceResponse = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  let normalizedValue = value.trim();

  if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
    normalizedValue = JSON.parse(normalizedValue);
  }

  return normalizedValue;
};

const base64_decode = (value) => rawBase64Decode(normalizeHistoryNfceResponse(value));

const isHistoryNfceAuthError = (xhr) => {
  const candidates = [xhr?.message, xhr?.responseText, xhr?.responseJSON];

  return candidates.some((value) => {
    if (value === 'erro_auth') {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    let normalizedValue = value.trim();

    if (normalizedValue.startsWith('"') && normalizedValue.endsWith('"')) {
      normalizedValue = JSON.parse(normalizedValue);
    }

    try {
      normalizedValue = base64_decode(normalizedValue);
    } catch (err) {
      return normalizedValue === 'erro_auth';
    }

    return normalizedValue === 'erro_auth';
  });
};

const handleHistoryNfceError = (xhr, reject, rejectMessage) => {
  if (isHistoryNfceAuthError(xhr)) {
    showDuplicateLoginAlert();
  }

  reject([400, { message: rejectMessage }]);
};

const getSession = () => {
  const usersRt = sessionStorage.getItem('ddesp');
  return usersRt !== null ? JSON.parse(base64_decode(usersRt)) : null;
};

const ajaxHistoryNfceEvent = ({
  type,
  pp,
  ll,
  dd,
  tk,
  parseType = 'base64',
  rejectMessage = 'erro',
  extraData = {},
  routeField = 'll',
  encodeRoute = true,
  encodeDd = true,
}) => new Promise(function (resolve, reject) {
  try {
    $.ajax({
      url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
      type,
      dataType: 'text',
      headers: {
        Authorization: 'Bearer ' + tk,
      },
      data: {
        pp: base64_encode(pp),
        [routeField]: encodeRoute ? base64_encode(ll) : ll,
        ...(encodeDd ? { dd: base64_encode(JSON.stringify(dd)) } : {}),
        tk,
        ...extraData,
      },
      success: function (data) {
        if (parseType === 'jsonBase64') {
          resolve([200, JSON.parse(base64_decode(data))]);
          return;
        }

        if (parseType === 'base64') {
          resolve([200, base64_decode(data)]);
          return;
        }

        resolve([200, data]);
      },
      error: function (xhr) {
        handleHistoryNfceError(xhr, reject, rejectMessage);
      },
    });
  } catch (err) {
    reject([500, { message: err + ' Server Error' }]);
  }
});

const RestHistoryNfcePost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = Arr_.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    case 'deleteMarcador':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'deleteMarcadores',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downXML':
      return ajaxHistoryNfceEvent({
        type: 'Get',
        pp: 'nfce',
        ll: 'dwnXml',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downloadLote':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'downloadLote',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downloadLoteTodas':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'downloadLoteTodas',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'enviaArquivosEmail':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'enviaArquivosEmail',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'enviaArquivosEmailTodos':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'enviaArquivosEmailTodos',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'eventos':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'situacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
        extraData: { tipo: 1 },
      });
    case 'hideMarcador':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'hideMarcadores',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'investigar':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'investigar',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'manifestacao':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'manifestacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'pesqNfce':
      return ajaxHistoryNfceEvent({
        type: 'Get',
        pp: 'nfce',
        ll: 'pesqNfce',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'printDanfe':
      return ajaxHistoryNfceEvent({
        type: 'Get',
        pp: 'nfce',
        ll: 'printDanfe',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'printComplementarProd':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'printComplementarProd',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'relComplementarProdutosLote':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'relComplementarProdutosLote',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'relComplementarProdutosLoteTodas':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'relComplementarProdutosLoteTodas',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'salvaConfigTabela':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'updateConfigTabela',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost, null, 2))],
        tk: token,
        extraData: { cf: Arr_.dataPost },
      });
    case 'salvaNovoMarcador':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'salvaNovoMarcadorNfce',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        extraData: { tipo: 'nfce' },
      });
    case 'setMarcador':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'setMarcador',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'showMarcador':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'showMarcadores',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'situacao':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'situacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
        extraData: { tipo: 0 },
      });
    case 'updateAnotacao':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'updateAnotacao',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
      });
    case 'downloadXmlsNfce':
      return ajaxHistoryNfceEvent({
        type: 'Post',
        pp: 'nfce',
        ll: 'downloadXmlsNfce',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(Arr_.dataPost))],
        tk: token,
        parseType: 'raw',
      });
    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

const RestHistoryNfceGet = (config) => {
  const caminho = config.dest.trim();
  const storage = getSession();
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  switch (caminho) {
    case 'getConfigTableNfce':
      return ajaxHistoryNfceEvent({
        type: 'Get',
        pp: 'nfce',
        ll: 'getConfigTableNfce',
        dd: [base64_encode(emp), base64_encode(uid)],
        tk: token,
      });
    case 'getItensNfce':
      return ajaxHistoryNfceEvent({
        type: 'Get',
        pp: 'nfce',
        ll: 'getItensNfce',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(config.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getMarcadores':
      return ajaxHistoryNfceEvent({
        type: 'Get',
        pp: 'nfce',
        ll: 'getMarcadores',
        dd: [base64_encode(emp), base64_encode(uid)],
        tk: token,
        parseType: 'jsonBase64',
      });
    case 'getVinculados':
      return ajaxHistoryNfceEvent({
        type: 'Get',
        pp: 'nfce',
        ll: 'getVinculadosNfce',
        dd: [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(config.dataPost))],
        tk: token,
        parseType: 'jsonBase64',
      });
    default:
      return new Promise((resolve, reject) => reject([404, { message: 'Rota não encontrada' }]));
  }
};

export { RestHistoryNfcePost, RestHistoryNfceGet };